import { render, staticRenderFns } from "./shopHead.vue?vue&type=template&id=8253c3d0&scoped=true"
import script from "./shopHead.vue?vue&type=script&lang=js"
export * from "./shopHead.vue?vue&type=script&lang=js"
import style0 from "./shopHead.vue?vue&type=style&index=0&id=8253c3d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8253c3d0",
  null
  
)

export default component.exports